import React from 'react';

import cx from 'classnames';
import styles from './styles.scss';

export default class Row extends React.PureComponent {
  render() {
    return <div className={cx(styles.row, this.props.className || '')}>{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./app/components/form/row.js